module.exports = __webpack_public_path__ + "img/order-setup-eat-in-table-without-new.ba050bc2.svg";